module.exports = __webpack_public_path__ + "static/media/invite-icon.2e232473.svg";